import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { CommonModule, JsonPipe } from '@angular/common';
import { LobbygramHookLinkDialogComponent } from './dialogs/lobbygram-hook-link-dialog/lobbygram-hook-link-dialog.component';
import { CoreModule } from 'src/app/core/core.module';
import { UtilsModule } from '../utils/utils.module';
import { BannerNotificationComponent } from './notifications/banner-notification/banner-notification.component';
import { BannerNotificationIconDirective } from './notifications/banner-notification/banner-notification-icon.directive';
import { BannerNotificationDirective } from './notifications/banner-notification/banner-notification.directive';
import { BannerNotificationInterdictionComponent } from './notifications/banner-notification/banner-notification-interdiction/banner-notification-interdiction.component';
import { BannerNotificationInterdictionMessagePipe } from './notifications/banner-notification/banner-notification-interdiction/banner-notification-interdiction-message.pipe';
import { EffectsModule } from '@ngrx/effects';
import { GlobalSpinnerEffects } from './global-spinner/global-spinner.effects';
import { DashboardFilterButtonComponent } from './dashboard/dashboard-filter-button/dashboard-filter-button.component';
import { FilterButtonEvaluationColorDirective } from './dashboard/dashboard-filter-button/filter-button-evaluation-color.directive';
import { GlobalSpinnerComponent } from './global-spinner/global-spinner.component';
import { DashboardHeaderComponent } from './dashboard/dashboard-header/dashboard-header.component';
import { PortalModule } from '@angular/cdk/portal';
import { OverlayModule } from '@angular/cdk/overlay';
import { TranslationsModule } from '../translations/translations.module';
import { AutocompleteComponent } from './inputs/autocomplete/autocomplete.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BannerNotificationLeadOfferComponent } from './notifications/banner-notification/banner-notification-lead-offer/banner-notification-lead-offer.component';
import { FilterContainerDisplayDirective } from './dashboard/dashboard-filter-button/filter-container-display.directive';
import { UserAvailabilityIconDirective } from './icons/user-availability-icon.directive';
import { ThirdLibModule } from './third-libs/third-lib.module';
import { MultiSelectionComponent } from './inputs/multi-selection/multi-selection.component';
import { AutoDisableMenuButtonComponent } from './inputs/auto-disable-menu-button/auto-disable-menu-button.component';
import { AutoDisableButtonDirective } from './inputs/auto-disable-menu-button/auto-disable-button.directive';
import { BannerNotificationOfferMessagePipe } from './notifications/banner-notification/banner-notification-lead-offer/banner-notification-offer-message.pipe';
import { BoardContactComponent } from './dashboard/dashboard-board/board-contact/board-contact.component';
import { ContactTypeIconDirective } from './icons/contact-type-icon.directive';
import { LeadQualificationOutcomeIconDirective } from './icons/lead-qualification-outcome-icon.directive';
import { LeadOfferActionAcceptIconDirective } from './icons/lead-offer-action-accept-icon.directive';
import { LeadOfferActionRejectIconDirective } from './icons/lead-offer-action-reject-icon.directive';
import { DashboardSortingButtonComponent } from './dashboard/dashboard-sorting-button/dashboard-sorting-button.component';
import { SidenavContentHeaderComponent } from './sidenav/sidenav-content-header/sidenav-content-header.component';
import { TranslateLeadOutcomePipe } from './pipes/translate-lead-outcome.pipe';
import { LeadInfoIconDirective } from './icons/lead-info-icon.directive';
import { AssignLeadDialogComponent } from './dialogs/assign-lead-dialog/assign-lead-dialog.component';
import { SidenavContentLeadInfoContainerComponent } from './sidenav/sidenav-content-lead-info-container/sidenav-content-lead-info-container.component';
import { SidenavContentLeadInfoStateHistoryComponent } from './sidenav/sidenav-content-lead-info-container/sidenav-content-lead-info-state-history/sidenav-content-lead-info-state-history.component';
import { SidenavContentLeadInfoAuditsComponent } from './sidenav/sidenav-content-lead-info-container/sidenav-content-lead-info-audits/sidenav-content-lead-info-audits.component';
import { MunicipalityAutocompleteComponent } from './inputs/autocomplete/municipality-autocomplete.component';
import { LabelValueInputComponent } from './inputs/label-value-input/label-value-input.component';
import { ConfirmDialogComponent } from './dialogs/confirm-dialog/confirm-dialog.component';
import { AggregateVersionErrorDialogComponent } from './dialogs/aggregate-version-error-dialog/aggregate-version-error-dialog.component';
import { ShowAutoAssignButtonPipe } from './sidenav/sidenav-content-lead-info-container/pipes/show-auto-assign-button.pipe';
import { SnackbarNotificationComponent as SnackbarNotificationComponent } from './notifications/snackbar-notification/snackbar-notification.component';
import { SidenavContentLeadInfoAuditsDetailsComponent } from './sidenav/sidenav-content-lead-info-container/sidenav-content-lead-info-audits/sidenav-content-lead-info-audits-details/sidenav-content-lead-info-audits-details.component';
import { AuditItemDirective } from './sidenav/sidenav-content-lead-info-container/sidenav-content-lead-info-audits/items/audit-item.directive';
import { AuditItemRevocationComponent } from './sidenav/sidenav-content-lead-info-container/sidenav-content-lead-info-audits/items/audit-item-revocation/audit-item-revocation.component';
import { AuditItemRefusalComponent } from './sidenav/sidenav-content-lead-info-container/sidenav-content-lead-info-audits/items/audit-item-refusal/audit-item-refusal.component';
import { AuditItemProcessingDoneComponent } from './sidenav/sidenav-content-lead-info-container/sidenav-content-lead-info-audits/items/audit-item-processing-done/audit-item-processing-done.component';
import { AuditItemOfferComponent } from './sidenav/sidenav-content-lead-info-container/sidenav-content-lead-info-audits/items/audit-item-offer/audit-item-offer.component';
import { AuditItemLogComponent } from './sidenav/sidenav-content-lead-info-container/sidenav-content-lead-info-audits/items/audit-item-log/audit-item-log.component';
import { AuditItemInjectionComponent } from './sidenav/sidenav-content-lead-info-container/sidenav-content-lead-info-audits/items/audit-item-injection/audit-item-injection.component';
import { AuditItemGenericComponent } from './sidenav/sidenav-content-lead-info-container/sidenav-content-lead-info-audits/items/audit-item-generic/audit-item-generic.component';
import { AuditItemExpirationComponent } from './sidenav/sidenav-content-lead-info-container/sidenav-content-lead-info-audits/items/audit-item-expiration/audit-item-expiration.component';
import { AuditItemDataChangeComponent } from './sidenav/sidenav-content-lead-info-container/sidenav-content-lead-info-audits/items/audit-item-data-change/audit-item-data-change.component';
import { LogAuditSeverityStyleDirective } from './sidenav/sidenav-content-lead-info-container/sidenav-content-lead-info-audits/items/audit-item-log/log-audit-severity-style.directive';
import { FilterAuditsPipe } from './sidenav/sidenav-content-lead-info-container/sidenav-content-lead-info-audits/filter-audits.pipe';
import { HumanizeTransitionSpanPipe } from './sidenav/sidenav-content-lead-info-container/sidenav-content-lead-info-state-history/humanize-transition-span.pipe';
import { TransitionCreationDatePipe } from './sidenav/sidenav-content-lead-info-container/sidenav-content-lead-info-state-history/transition-creation-date.pipe';
import { FormErrorViewComponent } from './forms/form-error-view/form-error-view.component';
import { SidenavContentLeadInjectorInfoContainerComponent } from './sidenav/sidenav-content-lead-injector-info-container/sidenav-content-lead-injector-info-container.component';
import { InjectorCurlSnippedDirective } from './sidenav/sidenav-content-lead-injector-info-container/injector-curl-snipped.directive';
import { InjectorHtmlSnippedDirective } from './sidenav/sidenav-content-lead-injector-info-container/injector-html-snipped.directive';
import { CalendarPickerComponent } from './inputs/calendar-picker/calendar-picker.component';
import { LeadInfoFormComponent } from './forms/lead-info-form/lead-info-form.component';
import { ConsentIconDirective } from './forms/lead-info-form/icons/consent-icon.directive';
import { IsBooleanRawvaluePipe, ToBooleanRawvaluePipe } from './forms/lead-info-form/pipes/boolean-rawvalue.pipe';
import { FilterConfiguredRawvaluesPipe } from './forms/lead-info-form/pipes/filter-configured-rawvalues.pipe';
import { ProjectLobbyErrorsMessagesPipe } from './forms/lead-info-form/pipes/project-lobby-errors-messages.pipe';
import { LeadCreateFormComponent } from './forms/lead-create-form/lead-create-form.component';
import { UserActionForbiddenDialogComponent } from './dialogs/user-action-forbidden-dialog/user-action-forbidden-dialog.component';
import { UserModule } from '../user/user.module';
import { GenericErrorDialogComponent } from './dialogs/generic-error-dialog/generic-error-dialog.component';
import { UserActionInvalidDialogComponent } from './dialogs/user-action-invalid-dialog/user-action-invalid-dialog.component';
import { DashboardBoardEmptyViewComponent } from './dashboard/dashboard-board/dashboard-board-empty-view/dashboard-board-empty-view.component';
import { AuditItemAssignmentComponent } from './sidenav/sidenav-content-lead-info-container/sidenav-content-lead-info-audits/items/audit-item-assignment/audit-item-assignment.component';
import { LeadReceivedInfoDialogComponent } from './dialogs/lead-received-info-dialog/lead-received-info-dialog.component';
import { SidenavContentUserInfoComponent } from './sidenav/sidenav-content-user-info/sidenav-content-user-info.component';
import { SocialFormIconDirective } from './icons/social-form-icon.directive';
import { APP_CONFIG } from '../configurations/configurations.factory';
import { IconRegistryService } from './icons/icon-registry.service';
import { ConnectivityErrorDialogComponent } from './dialogs/connectivity-error-dialog/connectivity-error-dialog.component';
import { SidenavContentFacebookFormContainerComponent } from './sidenav/sidenav-content-facebook-form-container/sidenav-content-facebook-form-container.component';
import { SidenavContentFacebookFormInfoComponent } from './sidenav/sidenav-content-facebook-form-container/sidenav-content-facebook-form-info/sidenav-content-facebook-form-info.component';
import { SidenavContentFacebookFormLogsComponent } from './sidenav/sidenav-content-facebook-form-container/sidenav-content-facebook-form-logs/sidenav-content-facebook-form-logs.component';
import { SidenavContentFacebookFormLogPayloadComponent } from './sidenav/sidenav-content-facebook-form-container/sidenav-content-facebook-form-logs/sidenav-content-facebook-form-log-payload/sidenav-content-facebook-form-log-payload.component';
import { SidenavContentFacebookFormLogItemComponent } from './sidenav/sidenav-content-facebook-form-container/sidenav-content-facebook-form-logs/sidenav-content-facebook-form-log-item/sidenav-content-facebook-form-log-item.component';
import { HumanizeLogPayloadPipe } from './sidenav/sidenav-content-facebook-form-container/sidenav-content-facebook-form-logs/sidenav-content-facebook-form-log-payload/humanize-log-payload.pipe';
import { LogStatusStyleDirective } from './sidenav/sidenav-content-facebook-form-container/sidenav-content-facebook-form-logs/sidenav-content-facebook-form-log-item/log-status-style.directive';
import { AuditItemCreationComponent } from './sidenav/sidenav-content-lead-info-container/sidenav-content-lead-info-audits/items/audit-item-creation/audit-item-creation.component';
import { AuditItemAutoOfferFailComponent } from './sidenav/sidenav-content-lead-info-container/sidenav-content-lead-info-audits/items/audit-item-auto-offer-fail/audit-item-auto-offer-fail.component';
import { ImportLeadsFromFileDialogComponent } from './dialogs/import-leads-from-file-dialog/import-leads-from-file-dialog.component';
import { DragDropDirective } from './directives/drag-drop.directive';
import { PivaPipe } from './dashboard/dashboard-board/pipes/piva.pipe';
import { BusinessNamePipe } from './dashboard/dashboard-board/pipes/business-name.pipe';
import { ItalianFiscalCodePipe } from './dashboard/dashboard-board/pipes/italian-fiscal-code.pipe';
import { ConfigurationsModule } from '../configurations/configurations.module';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { TimeInputComponent } from './inputs/time-input/time-input.component';
import { ValidatorColorDirective } from './directives/validator-color.directive';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatNativeDateModule } from '@angular/material/core';

@NgModule({
  declarations: [
    LobbygramHookLinkDialogComponent,
    BannerNotificationComponent,
    BannerNotificationIconDirective,
    BannerNotificationDirective,
    BannerNotificationInterdictionComponent,
    BannerNotificationInterdictionMessagePipe,
    DashboardFilterButtonComponent,
    FilterButtonEvaluationColorDirective,
    GlobalSpinnerComponent,
    DashboardHeaderComponent,
    AutocompleteComponent,
    BannerNotificationLeadOfferComponent,
    FilterContainerDisplayDirective,
    UserAvailabilityIconDirective,
    MultiSelectionComponent,
    AutoDisableMenuButtonComponent,
    AutoDisableButtonDirective,
    BannerNotificationOfferMessagePipe,
    BoardContactComponent,
    ContactTypeIconDirective,
    LeadQualificationOutcomeIconDirective,
    LeadOfferActionAcceptIconDirective,
    LeadOfferActionRejectIconDirective,
    DashboardSortingButtonComponent,
    SidenavContentHeaderComponent,
    TranslateLeadOutcomePipe,
    LeadInfoIconDirective,
    AssignLeadDialogComponent,
    SidenavContentLeadInfoContainerComponent,
    SidenavContentLeadInfoStateHistoryComponent,
    SidenavContentLeadInfoAuditsComponent,
    MunicipalityAutocompleteComponent,
    LabelValueInputComponent,
    FilterConfiguredRawvaluesPipe,
    ConsentIconDirective,
    ConfirmDialogComponent,
    IsBooleanRawvaluePipe,
    ToBooleanRawvaluePipe,
    AggregateVersionErrorDialogComponent,
    ShowAutoAssignButtonPipe,
    SnackbarNotificationComponent,
    SidenavContentLeadInfoAuditsDetailsComponent,
    AuditItemDirective,
    AuditItemRevocationComponent,
    AuditItemRefusalComponent,
    AuditItemProcessingDoneComponent,
    AuditItemOfferComponent,
    AuditItemLogComponent,
    AuditItemInjectionComponent,
    AuditItemGenericComponent,
    AuditItemExpirationComponent,
    AuditItemDataChangeComponent,
    AuditItemAssignmentComponent,
    LogAuditSeverityStyleDirective,
    FilterAuditsPipe,
    LeadReceivedInfoDialogComponent,
    HumanizeTransitionSpanPipe,
    TransitionCreationDatePipe,
    FormErrorViewComponent,
    ProjectLobbyErrorsMessagesPipe,
    SidenavContentLeadInjectorInfoContainerComponent,
    InjectorCurlSnippedDirective,
    InjectorHtmlSnippedDirective,
    CalendarPickerComponent,
    TimeInputComponent,
    LeadInfoFormComponent,
    LeadCreateFormComponent,
    UserActionForbiddenDialogComponent,
    GenericErrorDialogComponent,
    UserActionInvalidDialogComponent,
    DashboardBoardEmptyViewComponent,
    SidenavContentUserInfoComponent,
    AuditItemCreationComponent,
    AuditItemAutoOfferFailComponent,
    SidenavContentFacebookFormInfoComponent,
    SocialFormIconDirective,
    SidenavContentFacebookFormLogsComponent,
    SidenavContentFacebookFormContainerComponent,
    SidenavContentFacebookFormLogPayloadComponent,
    SidenavContentFacebookFormLogItemComponent,
    HumanizeLogPayloadPipe,
    LogStatusStyleDirective,
    AuditItemCreationComponent,
    ConnectivityErrorDialogComponent,
    AuditItemCreationComponent,
    ImportLeadsFromFileDialogComponent,
    DragDropDirective,
    PivaPipe,
    BusinessNamePipe,
    ItalianFiscalCodePipe,
    ValidatorColorDirective
  ],
  imports: [

    NgxDaterangepickerMd.forRoot(),
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CoreModule,
    ThirdLibModule,
    TranslationsModule,
    UtilsModule,
    OverlayModule,
    UserModule,
    PortalModule,
    ConfigurationsModule,
    EffectsModule.forFeature([GlobalSpinnerEffects]),
    MatMomentDateModule,
    MatNativeDateModule
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    LobbygramHookLinkDialogComponent,
    BannerNotificationComponent,
    BannerNotificationInterdictionComponent,
    DashboardHeaderComponent,
    DashboardFilterButtonComponent,
    ThirdLibModule,
    AutocompleteComponent,
    UserAvailabilityIconDirective,
    MultiSelectionComponent,
    AutoDisableMenuButtonComponent,
    AutoDisableButtonDirective,
    BannerNotificationLeadOfferComponent,
    BoardContactComponent,
    LeadQualificationOutcomeIconDirective,
    LeadOfferActionAcceptIconDirective,
    LeadOfferActionRejectIconDirective,
    DashboardSortingButtonComponent,
    SidenavContentHeaderComponent,
    TranslateLeadOutcomePipe,
    LeadInfoIconDirective,
    SidenavContentLeadInfoContainerComponent,
    LeadInfoFormComponent,
    SidenavContentLeadInfoStateHistoryComponent,
    SidenavContentLeadInfoAuditsComponent,
    ConfirmDialogComponent,
    SidenavContentLeadInjectorInfoContainerComponent,
    LeadCreateFormComponent,
    DashboardBoardEmptyViewComponent,
    SidenavContentUserInfoComponent,
    ImportLeadsFromFileDialogComponent,
    DragDropDirective,
    SidenavContentFacebookFormInfoComponent,
    SocialFormIconDirective,
    SidenavContentFacebookFormContainerComponent,
    PivaPipe,
    BusinessNamePipe,
    ItalianFiscalCodePipe,
    ValidatorColorDirective,
    MatMomentDateModule
  ],
  providers: [
    provideAppInitializer(() => {
      const initializerFn = ((iconRegistryService: IconRegistryService) => () => iconRegistryService.load())(inject(IconRegistryService));
      return initializerFn();
    }),
    JsonPipe,
  ]
})
export class UiKitModule { }

